import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { ApiService } from 'app/services/api/api.service';



@Injectable()
export class UserProfileService implements Resolve<any>
{
    user: any;
    routeParams: any;
    userOnChanged: BehaviorSubject<any>;
    constructor(private _http: HttpClient, private _apiService: ApiService)
    {
       this.userOnChanged = new BehaviorSubject({});
    }

    /**
     * Resolve
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     * @returns {Observable<any> | Promise<any> | any}
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any
    {
        this.routeParams = route.params;
        return new Promise((resolve, reject) => {
            Promise.all([
                this.me()
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    me(){

        return new Promise((resolve, reject) => {
            this._http.get(this._apiService.user.me())
            .map((res: any) => res.data)
                .subscribe((user: any) => {
                    this.user = user;
                    this.userOnChanged.next(this.user);
                    resolve(user);
                }, reject);
        });

    }

    update(data){
        return new Promise((resolve, reject) => {
            this._http.put(this._apiService.user.update() , { ...data})
            .subscribe((response: any) => {
                    resolve(response);
                }, (error: HttpErrorResponse) => {
                    reject(error);
                });
        });
    }

    reset_password(data){
        return new Promise((resolve, reject) => {
            this._http.post(this._apiService.user.reset_password() , { ...data})
            .subscribe((response: any) => {
                    resolve(response);
                }, (error: HttpErrorResponse) => {
                    reject(error);
                });
        });
    }





}


